import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import routes from "./routes"; // Adjust the path if kept in the same file
import PrivateRoute from "./components/PrivateRoute";
import { useSelector } from "react-redux";
import GlobalLoader from "./components/globalLoader/GlobalLoader";
// 
function App() {
  const { loading } = useSelector((state) => state.auth);

  return (
    <>
      {loading && <GlobalLoader />}

      <Router>
        <Routes>
          {routes.map(({ path, element, isProtected }, index) => (
            <Route
              key={index}
              path={path}
              element={
                isProtected ? (
                  <PrivateRoute>{element}</PrivateRoute>
                ) : (
                  element
                )
              }
            />
          ))}
        </Routes>
      </Router>
    </>
  );
}


export default App;
